export default "__VITE_ASSET__D2vNAP9w__"